import { IconProps } from "@utils/types/components";

export const QuizIcon = ({
  width,
  height,
  color = "currentcolor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 27 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.333 23.288h10c.473 0 .868-.14 1.188-.418.32-.279.479-.625.479-1.037 0-.412-.16-.758-.48-1.037-.319-.28-.714-.419-1.187-.419h-10c-.472 0-.868.14-1.187.419-.32.279-.48.625-.48 1.037 0 .412.16.758.48 1.037.32.279.715.418 1.187.418zm0-5.822h10c.473 0 .868-.14 1.188-.418.32-.28.479-.625.479-1.037 0-.413-.16-.758-.48-1.037-.319-.28-.714-.419-1.187-.419h-10c-.472 0-.868.14-1.187.419-.32.279-.48.624-.48 1.037 0 .412.16.758.48 1.037.32.279.715.418 1.187.418zm-5 11.644c-.916 0-1.701-.284-2.354-.855C.326 27.685 0 27 0 26.2V2.91c0-.8.326-1.486.98-2.056C1.631.285 2.416 0 3.332 0h11.959c.444 0 .868.073 1.27.218.403.146.757.352 1.063.619l8.083 7.06c.306.266.542.575.709.927.166.352.25.722.25 1.11V26.2c0 .8-.327 1.485-.98 2.055-.652.57-1.437.855-2.354.855h-20zM15 8.733V2.911H3.333V26.2h20V10.19h-6.666c-.473 0-.868-.14-1.188-.419A1.322 1.322 0 0115 8.733z"
        fill={color}
      />
    </svg>
  );
};
